import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { baseUrl } from "../../../enum/constant";

const TransactionProof = ({ transationProof }) => {
    // transactionId, userEmail, transaction_type, criptoname, currencyname, crypto_amount, converted_amount, wallet_address
    const location = useLocation();
    const navigate = useNavigate();

    const {
        transactionId,
        userEmail,
        transaction_type,
        criptoname,
        currencyname,
        crypto_amount,
        converted_amount,
        wallet_address,
    } = location.state || transationProof;

    const [bankInfoList, setBankInfoList] = useState([]); // State to hold bank info
    const [timeLeft, setTimeLeft] = useState(15 * 60);
    const [isRunning, setIsRunning] = useState(true);
    const [file, setFile] = useState(null);
    const [isExpired, setIsExpired] = useState(false);
    const [isUploading, setUploading] = useState(false);
    const [hashTransactionId, setHashTransactionId] = useState(""); // Store hash transaction id
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Fetch bank info based on currencyname
        const fetchBankInfo = async () => {
            try {
                let currencyCode = currencyname;
                if (currencyname === "United States Dollar") {
                    currencyCode = "USD";
                } else if (currencyname === "Euro") {
                    currencyCode = "EUR";
                }
                const base = baseUrl;
                const url = `${base}api/bank-info/${currencyCode}-currency`;
                const response = await axios.get(url);
                setBankInfoList(
                    Array.isArray(response.data) ? response.data : [response.data]
                );
            } catch (error) {
                console.error("Error fetching bank info:", error);
            }
        };

        if (currencyname) {
            fetchBankInfo();
        }
    }, [currencyname]);

    useEffect(() => {
        let interval;
        // const border = document.getElementById("borderStroke");

        // const totalLength = border.getTotalLength();
        // border.style.strokeDasharray = totalLength;
        // border.style.strokeDashoffset = 0;

        if (isRunning && timeLeft > 0) {
            interval = setInterval(() => {

                // const percent = timeLeft / (15 * 60);
                // border.style.strokeDashoffset = totalLength * (1 - percent);

                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        // border.style.strokeDashoffset = totalLength;
                        clearInterval(interval);
                        setIsExpired(true);
                        //     setTimeout(() => navigate("/"), 4000);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [isRunning, timeLeft, navigate]);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async () => {
        if (loading) {
            alert("Please wait, your previous request is processing...");
            return;
        }
        if (transaction_type === "sell") {
            // Handle 'sell' case: submit transaction ID
            if (!hashTransactionId) {
                alert("Please provide a valid transaction ID.");
                return;
            }
            setLoading(true);

            // Create FormData to include transaction info
            const formData = new FormData();
            formData.append("hash_transaction_id", hashTransactionId); // Add hashTransactionId to formData
            formData.append("id", transactionId); // Add the original transaction ID
            formData.append("status", 2); // Example status
            formData.append("email", userEmail); // User's email

            try {
                const base = baseUrl;
                // API call for 'sell' transaction type
                const response = await axios.post(
                    base + "api/hash-TransictionId",
                    formData, // Send the formData with all the additional fields
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            "Content-Type": "multipart/form-data", // Ensure proper header for FormData
                        },
                    }
                );

                setLoading(false);
                if (response.status === 200) {
                    setSuccessMessage("Transaction ID submitted successfully!");
                    // setTimeout(() => {
                    //     setSuccessMessage("");
                    //     navigate("/success");
                    // }, 3000);
                } else {
                    throw new Error("Failed to submit transaction ID.");
                }
            } catch (err) {
                setLoading(false);
                console.error("Error submitting transaction ID:", err);
                setErrorMessage("Failed to submit transaction ID.");
                setTimeout(() => {
                    setErrorMessage("");
                }, 3000);
            }
        } else if (transaction_type === "buy") {
            // Handle 'buy' case: upload transaction proof
            if (!file) {
                alert("Please select a file before submitting.");
                return;
            }

            setUploading(true);
            setLoading(true);

            const formData = new FormData();
            formData.append("payment_prof", file); // Add the selected file
            formData.append("id", transactionId); // Add the original transaction ID
            formData.append("status", 2); // Example status
            formData.append("email", userEmail); // User's email

            try {
                const base = baseUrl;
                await axios.post(
                    base + "api/upload-payment-prof",
                    formData, // Send the formData with the file and transaction info
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            "Content-Type": "multipart/form-data", // Ensure proper header for FormData
                        },
                    }
                );
                setLoading(false);
                setSuccessMessage("File uploaded successfully!");
                // setTimeout(() => {
                //     setSuccessMessage("");
                //     navigate("/success");
                // }, 3000);
            } catch (err) {
                setLoading(false);
                console.error("Error uploading file:", err);
                setErrorMessage("Failed to upload file.");
                setTimeout(() => {
                    setErrorMessage("");
                }, 3000);
            } finally {
                setLoading(false);
                setUploading(false);
                setFile(null); // Reset the file after upload
            }
        }
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    return (
        <div className="col-md-6 cus-col-6 pb-3">
            <div className="crp-form px-0">
                <h3>{transaction_type == 'sell' ? 'Sell' : 'Buy'} {transationProof.criptoname}</h3>
                <div className="fom-wrap">
                    {timeLeft > 0 && !isExpired ? (
                        <>
                            {
                                !successMessage && (
                                    <div class="timer-wrapper">
                                        <div class="timer-container">
                                            <span id="timeText">{formatTime(timeLeft)}</span>
                                        </div>
                                        {/* <svg class="timer-svg" width="260" height="50" viewBox="0 0 260 50">
                                    <path
                                        id="borderStroke"
                                        d="
                                        M130,2 
                                        H230 
                                        A25,25 0 0 1 255,27 
                                        V23 
                                        A25,25 0 0 1 230,48 
                                        H30 
                                        A25,25 0 0 1 5,23 
                                        V27 
                                        A25,25 0 0 1 30,2 
                                        H130
                                    "
                                    />
                                </svg> */}
                                    </div>
                                )
                            }
                            {
                                transaction_type == 'buy' ? (
                                    <div>
                                        <div className="crypto-curr-div">
                                            <div className="address-network">
                                                <div>
                                                    {/* <img className="mr-2" src="images/currency/eur_2fb3ea3cae.svg" /> */}
                                                    <span className="bold-color">{converted_amount} </span>
                                                    <span> {currencyname}</span>
                                                </div>
                                                <div>
                                                    <img src="assets/images/arrow-custom-right.png" alt="" />
                                                </div>
                                                <div>
                                                    <span className="bold-color"> {crypto_amount} </span>
                                                    <span> {criptoname}</span>
                                                    {/* <img className="ml-2" width={20} src="images/eth.svg" /> */}
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="">
                                                <p className="text-muted">Funds will be transferred to this address</p>
                                                <div className="address-network">
                                                    <span className="bold-color" style={{ overflowX: "auto" }}>{wallet_address}</span>
                                                    {/* <span>ERC-20</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            successMessage ? (
                                                <div className="crypto-curr-div">
                                                    <div>
                                                        <h5>
                                                            Thank you! Awaiting funds.
                                                        </h5>
                                                        <p className="text-muted">
                                                            We've started processing your request. Once the payment is received, the cryptocurrency will be sent to your wallet.
                                                        </p>
                                                        <p className="text-muted">
                                                            If anything goes wrong, please contact our support team.
                                                        </p>
                                                        <Link to="/contact-us" className="btn btn-cta w-100">Contact Support</Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="crypto-curr-div">
                                                        <div>
                                                            <span className="bold-color">
                                                                1. Send funds to the provided account
                                                            </span>
                                                            <p className="text-muted">
                                                                Use a bank transfer or card payment to send the amount to the given details.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="crypto-curr-div">
                                                        <div>
                                                            <span className="bold-color">
                                                                2. Upload payment confirmation
                                                            </span>
                                                            <p className="text-muted">
                                                                Attach a photo or screenshot of your transfer to speed up the processing.
                                                            </p>
                                                            <div className="cus-file-drag">
                                                                {
                                                                    !file ? (

                                                                        <label className={`upload-box`}>
                                                                            <input onChange={handleFileChange} type="file" id="fileInput" />
                                                                            <div class="upload-content">
                                                                                <img src="assets/images/upload.png" />
                                                                                <span>Drag & Drop or <span class="choose-file">Choose file</span> to upload</span>
                                                                            </div>
                                                                        </label>
                                                                    ) : (
                                                                        <div className={`file-preview`} id="filePreview">
                                                                            <div class="file-icon">📄</div>
                                                                            <div class="file-info">
                                                                                <div class="file-name" id="fileName">{file.name}</div>
                                                                                <div class="file-size" id="fileSize">{file.size} KB</div>
                                                                            </div>
                                                                            <div class="remove-btn" onClick={() => setFile(null)} id="removeBtn">✕</div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }

                                    </div>
                                ) : transaction_type == 'sell' ? (
                                    <div className="">
                                        <div className="crypto-curr-div">
                                            <div className="address-network">
                                                <div>
                                                    {/* <img className="mr-2" width={20} src="images/eth.svg" /> */}
                                                    <span className="bold-color"> {crypto_amount} </span>
                                                    <span> {criptoname}</span>
                                                </div>
                                                <div>
                                                    <img src="assets/images/arrow-custom-right.png" alt="" />
                                                </div>
                                                <div>
                                                    <span className="bold-color"> {converted_amount} </span>
                                                    <span> {currencyname}</span>
                                                    {/* <img className="ml-2" src="images/currency/eur_2fb3ea3cae.svg" /> */}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            successMessage ? (
                                                <div className="crypto-curr-div">
                                                    <div>
                                                        <h5>
                                                            Thank you! Awaiting funds.
                                                        </h5>
                                                        <p className="text-muted">
                                                            We've started processing your request. Once the crypto is received, fiat will be credited to your specified account.
                                                        </p>
                                                        <p className="text-muted">
                                                            If there are any issues, please contact our support team.
                                                        </p>
                                                        <Link to="/contact-us" className="btn btn-cta w-100">Contact Support</Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="crypto-curr-div">
                                                        <div>
                                                            <span className="bold-color">
                                                                1. Send cryptocurrency to the provided wallet
                                                            </span>
                                                            <p className="text-muted">
                                                                Transfer the amount to the provided address using the correct network.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="crypto-curr-div">
                                                        <div>
                                                            <span className="bold-color">
                                                                2. For confirmation, enter transaction hash
                                                            </span>
                                                            <p className="text-muted">
                                                                The funds will be credited to your account after the crypto is received.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="field-bg mt-4">
                                                        <label for="">Hash transaction</label>
                                                        <input
                                                            className="wallet-input"
                                                            type="text"
                                                            placeholder="0xABC123..."
                                                            name="hash_transaction_id"
                                                            value={hashTransactionId}
                                                            onChange={(e) => setHashTransactionId(e.target.value)}
                                                        />
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                ) : null
                            }
                            {
                                !successMessage && (
                                    <div className="button-group mt-2" >
                                        {/* <div>
                                        {error && <div className="alert alert-danger text-center mb-3">{error}</div>}
                                        {success && (
                                            <div className="alert alert-success text-center mb-3">{success}</div>
                                        )}
                                    </div> */}

                                        <Link
                                            to="#"
                                            className={`btn grey-btn ${transaction_type == 'buy' ? (file ? 'btn-hovered' : ''): (hashTransactionId ? 'btn-hovered' : '')}`}
                                            onClick={handleSubmit}
                                        >
                                            Confirm transfer
                                        </Link>
                                    </div>
                                )
                            }
                        </>
                    ) : (
                        <p
                            className="card-text text-center"
                            style={{ fontSize: "2em", color: "red" }}
                        >
                            Time Expired! Try Again
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default TransactionProof;